import React from "react";
import Style from "./PageTop.module.css";
import { Avatar, Wrap, WrapItem } from "@chakra-ui/react";

function PageTop() {
  return (
    <div className={Style.pagetop}>
      <div className={Style.avatar}>
        <Wrap>
          <WrapItem>
            <Avatar
              style={{ color: "#ffffff" }}
              size="sm"
              bg="teal.500"
              name="falola adedayo"
            />
          </WrapItem>
        </Wrap>
      </div>
    </div>
  );
}

export default PageTop;
